var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloudViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#F4EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7685_176858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 20.6667L18 18.0001M18 18.0001L15.3333 20.6667M18 18.0001V24.0001M23.5933 22.2601C24.2435 21.9056 24.7572 21.3447 25.0532 20.6658C25.3493 19.987 25.4108 19.2289 25.2281 18.5112C25.0454 17.7935 24.629 17.1571 24.0444 16.7024C23.4599 16.2477 22.7406 16.0006 22 16.0001H21.16C20.9582 15.2196 20.5821 14.495 20.0599 13.8807C19.5378 13.2665 18.8832 12.7786 18.1454 12.4538C17.4075 12.129 16.6057 11.9756 15.8001 12.0053C14.9944 12.035 14.206 12.2469 13.4941 12.6252C12.7822 13.0034 12.1652 13.5381 11.6897 14.1891C11.2142 14.8401 10.8924 15.5904 10.7486 16.3837C10.6048 17.1769 10.6427 17.9924 10.8594 18.7689C11.0762 19.5454 11.4661 20.2626 12 20.8667",
    stroke: "#7F56D9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05887 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05887 27.9411 0 18 0V4ZM18 0C8.05887 0 0 8.05887 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "#F9F5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7685_176858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudViolet);
export default __webpack_public_path__ + "static/media/upload-cloud-violet.419690bd.svg";
export { ForwardRef as ReactComponent };